<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title">Api Kullanıcıları</div>
            <div slot="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box">
                            <table class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th style="width: 50px;">ID</th>
                                        <th>Açıklama</th>
                                        <th>Açık Anahtar</th>
                                        <th style="width: 80px;">Durumu</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items">
                                        <td>{{ item.id }}</td>
                                        <td>
                                            <router-link :to="{path: '/api-users/save', query: {id: item.id }}"><i class="fa fa-edit"></i> {{ item.name }}</router-link>
                                        </td>
                                        <td>{{ item.publicKey }}</td>
                                        <td>
                                            <label class="tag" :class="{'tag-warning': item.status == 0, 'tag-success': item.status == 1}">
                                                <span v-if="item.status == 1">Aktif</span>
                                                <span v-if="item.status == 0">Pasif</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr v-if="!items">
                                        <td colspan="4">
                                            <div class="alert alert-info">
                                                Herhangi bir kayıt bulunmamakta.
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '../components/app_layout.vue';

export default {
    components: {
        'app-layout': AppLayout
    },
    data: function () {
        return {
            items: [],
            loading: false
        }
    },
    mounted: function () {
        var $this = this;
        this.loading = true;
        $this.$app.get('/api/v1/api-users/search', function(xhr) {
            var response = xhr.responseJSON;
            $this.items = response.apiUsers;
            $this.loading = false;
        });
    }
}
</script>



// WEBPACK FOOTER //
// api_users.vue?ac169a0e